exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-root .main{display:flex;background-color:#e0e0e0}app-root ::-webkit-scrollbar{width:10px}app-root ::-webkit-scrollbar-track{background-color:#fafafa}app-root ::-webkit-scrollbar-thumb{width:10px;border-radius:20px;background:#e5e5e5}app-root ::-webkit-scrollbar-thumb:hover{background:#d1d1d1}", ""]);

// exports
